import { Component } from '../core/smpl-components.js'
import EmblaCarousel from 'embla-carousel'

// -----------------------------------------------------------------------------
// Product gallery — the cover and its extra images on the single product page.
//
// Embla turns the slides into a swipeable row. On desktop the thumbnails below
// pick a slide; on mobile (CSS hides the thumbs) a next arrow hints that the
// images can be swiped. The left/right arrow keys step through the images
// anywhere on the page, except while typing in a field. With a single image
// the template renders no controls and nothing is set up.
// Selector: `.js-product-gallery`.
// -----------------------------------------------------------------------------
export default class extends Component {
	prepare() {
		this.elViewport = this.element.querySelector('.product-detail__viewport')
		this.elNext = this.element.querySelector('.product-detail__next')
		this.thumbs = Array.from(this.element.querySelectorAll('.product-detail__thumb'))

		this.bndOnNextClick = this.onNextClick.bind(this)
		this.bndOnThumbClick = this.onThumbClick.bind(this)
		this.bndOnKeydown = this.onKeydown.bind(this)
		this.bndUpdate = this.update.bind(this)
	}

	mount() {
		if (this.thumbs.length < 2) return

		this.embla = EmblaCarousel(this.elViewport, { loop: false, align: 'center' })
		this.embla.on('select', this.bndUpdate)

		this.elNext?.addEventListener('click', this.bndOnNextClick)
		this.thumbs.forEach((el) => el.addEventListener('click', this.bndOnThumbClick))
		document.addEventListener('keydown', this.bndOnKeydown)

		this.update()
	}

	unmount() {
		if (!this.embla) return

		this.elNext?.removeEventListener('click', this.bndOnNextClick)
		this.thumbs.forEach((el) => el.removeEventListener('click', this.bndOnThumbClick))
		document.removeEventListener('keydown', this.bndOnKeydown)

		this.embla.destroy()
		this.embla = null
	}

	onNextClick() {
		this.embla.scrollNext()
	}

	onThumbClick(ev) {
		this.embla.scrollTo(this.thumbs.indexOf(ev.currentTarget))
	}

	onKeydown(ev) {
		if (ev.altKey || ev.ctrlKey || ev.metaKey || ev.shiftKey) return
		// Arrow keys move the caret in fields, e.g. the quantity input.
		if (ev.target.closest('input, textarea, select, [contenteditable]')) return

		if (ev.key === 'ArrowLeft') {
			this.embla.scrollPrev()
		} else if (ev.key === 'ArrowRight') {
			this.embla.scrollNext()
		}
	}

	update() {
		const index = this.embla.selectedScrollSnap()

		this.thumbs.forEach((el, i) => {
			el.classList.toggle('is-active', i === index)
			if (i === index) {
				el.setAttribute('aria-current', 'true')
			} else {
				el.removeAttribute('aria-current')
			}
		})

		this.elNext?.classList.toggle('is-disabled', !this.embla.canScrollNext())
	}
}
